const rankingItems = [
  { rank: 1, title: '咒术回战', category: '热血·日漫', heat: '9.8', change: 'up', desc: '咒术师的战斗与宿命，涩谷事变终章引爆全网' },
  { rank: 2, title: '我独自升级', category: '战斗·韩漫', heat: '9.7', change: 'up', desc: '从最弱到最强的逆袭之路，韩漫巅峰之作' },
  { rank: 3, title: '一人之下', category: '奇幻·国漫', heat: '9.6', change: 'same', desc: '异人世界的精彩冒险，国漫标杆级作品' },
  { rank: 4, title: '间谍过家家', category: '搞笑·日漫', heat: '9.5', change: 'up', desc: '间谍、杀手、超能力少女组成的伪装家庭' },
  { rank: 5, title: '全知读者视角', category: '奇幻·韩漫', heat: '9.4', change: 'down', desc: '小说变成现实，唯一知晓结局的读者展开生存' },
  { rank: 6, title: '镖人', category: '武侠·国漫', heat: '9.3', change: 'up', desc: '硬核武侠漫画，西域大漠中的刀客传奇' },
  { rank: 7, title: '葬送的芙莉莲', category: '奇幻·日漫', heat: '9.2', change: 'new', desc: '勇者死后，精灵魔法使踏上理解人类的旅程' },
];

const changeIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-accent-500' },
  same: { icon: 'ri-subtract-line', color: 'text-foreground-400' },
  new: { icon: 'ri-sparkling-line', color: 'text-secondary-500' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          酷漫屋本周最受读者欢迎的漫画作品
        </p>

        <div className="space-y-2">
          {rankingItems.map((item) => {
            const change = changeIcons[item.change];
            return (
              <div
                key={item.rank}
                className="flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl border border-background-200/80 p-4 cursor-pointer hover:border-primary-200/60 transition-colors"
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.title}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.category}</span>
                  </div>
                  <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500 text-xs"></i>
                    <span className="text-sm font-bold text-foreground-800">{item.heat}</span>
                  </div>
                  <i className={`${change.icon} ${change.color} text-sm`}></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}